/** matching — EN source (71 keys). */
export const matching = {
  location_disabled_title: "Connection Unavailable",
  location_disabled_description:
    "To use {name}, please enable location sharing so we can show you who's nearby.",
  location_disabled_hint:
    "Navigate to Settings -> {name} -> Location -> Enable Location While Using App",
  location_disabled_button: "Open Settings",
  matching_no_potential_matches_title: "Oops!",
  matching_no_potential_matches_description:
    "We can no longer find people near you, please try again later",
  matching_no_potential_matches_button: "Try again",
  matching_loading_matches_title: "Finding the Perfect Match...",
  matching_loading_matches_description:
    "Hang tight — we're scanning profiles to find the best connections for you. This won't take long.",
  matching_matched_title: "It's a match!",
  matching_matched_user_title: "You've linqed with {name}! ",
  matching_matched_user_button: "Choose your linkup location",
  matching_pick_location_button: "Pick a meeting spot",
  match_location_new_matches: "NEW MATCHES ({count})",
  match_location_pick: "Pick location",
  match_location_your_turn: "Your turn",
  match_location_waiting_short: "Waiting",
  match_location_pick_spot_title: "Pick a spot to meet {name}",
  match_location_popular_spots: "POPULAR SPOTS NEARBY",
  match_location_proposed_spots: "PROPOSED SPOTS",
  match_location_suggest_different: "Suggest a different place",
  match_location_enter_custom: "Enter custom location",
  match_location_your_pick: "YOU",
  match_location_their_pick: "{name}",
  match_location_waiting: "Waiting for {name} to pick...",
  match_location_different_picks: "Different picks!",
  match_location_different_picks_hint: "Pick the same spot to match!",
  match_location_accept_their_spot: "Accept their spot",
  match_location_change_pick: "Change my pick",
  match_location_select: "Select",
  match_location_confirm: "Confirm Location",
  match_location_confirmed_title: "It's a match!",
  match_location_confirmed_subtitle: "You and {name} both picked",
  match_location_start_chatting: "Start Chatting",
  match_location_meeting_at: "Meeting at {name}",
  match_location_navigate: "Navigate",
  match_location_search_placeholder: "Search for a place...",
  match_location_category_cafe: "Coffee Shop",
  match_location_category_restaurant: "Restaurant",
  match_location_category_park: "Park",
  match_location_category_bar: "Bar",
  match_location_category_museum: "Museum",
  match_location_category_mall: "Mall",
  match_location_category_other: "Other",
  match_location_distance_mi: "{distance} mi",
  match_location_error_propose: "Failed to propose location",
  match_location_error_load_spots: "Failed to load spots",
  match_location_pick_title: "Pick a spot to meet {name}",
  match_location_loading_spots: "Loading spots...",
  match_location_no_spots: "No spots available nearby",
  match_location_no_spots_hint: "Try suggesting your own place below",
  match_location_header_title: "Picking Location",
  match_location_or: "OR",
  // --- Meetup card (always present in 1:1 match chats) ---
  match_location_card_booked: "Booked ✅",
  match_location_card_pick_spot: "Pick a spot",
  match_location_card_waiting: "Waiting for {name}",
  match_location_card_your_turn: "Your turn",
  match_location_card_different_picks: "Different picks",
  match_location_card_no_spot_yet: "No spot yet",
  match_location_card_closed: "Match closed",
  match_location_no_events_nearby: "No events nearby",
  match_location_no_events_nearby_hint: "Try again later",
  match_location_awaiting_decision: "How was your meetup with {name}?",
  match_location_awaiting_decision_pill: "Decide first",
  match_location_you_picked: "You picked {event}",
  match_location_they_picked: "{name} picked {event}",
  match_location_default_name: "Your match",
  match_location_default_title: "Meeting location",
  match_location_change_spot: "Change spot",
  match_location_unmatched_message: "This match is closed.",
  match_location_unmatched_subtitle:
    "You can keep the conversation, but this meetup is over.",
  match_location_suggest_place: "Suggest a different place",
  match_location_custom_instructions:
    "Enter a place where you'd like to meet. Include the name and address so your match can find it.",
  match_location_name_label: "Place name",
  match_location_name_placeholder: "e.g., Central Park, My favorite café",
  match_location_address_label: "Address (optional)",
  match_location_address_placeholder: "e.g., 123 Main Street",
  match_location_use_current: "Use my current location",
  match_location_coordinates_set: "Location coordinates set",
  match_location_preview: "Your suggestion",
  match_location_confirm_location: "Confirm Location",
  match_location_permission_denied_title: "Location Permission",
  match_location_permission_denied_message:
    "Please enable location permissions in your device settings to use this feature.",
  match_location_get_location_error: "Failed to get your current location",
  match_location_name_required: "Please enter a place name",
  match_location_propose_error: "Failed to suggest location. Please try again.",
  match_location_chat_error: "Failed to open chat. Please try again.",
};
